<form data-testid="adx-invoice-info-form" class="template-form adx-invoice-info-form">  
    <div data-testid="adx-invoice-info-main-div" class="filter__fields">
        <mat-card class="mat-elevation-z8">
            <mat-card-content>
                <mat-grid-list data-testid="adx-invoice-info-grid-list" [cols]="2" gutterSize="10px" rowHeight="90">
                    <mat-grid-tile data-testid="adx-invoice-info-profile-name-grid-tile">
                        <read-only-form-field title="Client Name" testId="adx-invoice-info-profile-name" value="{{_adxInvoice.client?.profileName}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-record-locator-grid-tile">
                        <read-only-form-field title="Invoice Record Locator" testId="adx-invoice-info-record-locator" value="{{_adxInvoice.recordLocator}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-invoice-type-code-grid-tile">
                        <read-only-form-field title="Invoice Type" testId="adx-invoice-info-invoice-type-code" value="{{_adxInvoice.invoiceTypeCode}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-issue-date-grid-tile">
                        <read-only-form-field title="Issue Date" testId="adx-invoice-info-issue-date" value="{{_adxInvoice.issueDate | date:'M/d/yyyy'}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-branch-name-grid-tile">
                        <read-only-form-field title="Branch" testId="adx-invoice-info-branch-name" value="{{_adxInvoice.branch?.name}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-branch-number-grid-tile">
                        <read-only-form-field title="Branch Number" testId="adx-invoice-info-branch-number" value="{{_adxInvoice.branch?.branchNo}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-invoice-group-grid-tile">
                        <read-only-form-field title="Invoice Group" testId="adx-invoice-info-invoice-group" value="{{_adxInvoice.invoiceGroup}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-data-source-grid-tile">
                        <read-only-form-field title="Data Source Name" testId="adx-invoice-info-data-source" value="{{_adxInvoice.tramsDataSource?.displayName}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-remarks-grid-tile">
                        <read-only-form-field title="Remarks" testId="adx-invoice-info-remarks" value="{{_adxInvoice.remarks}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-res-card-number-grid-tile">
                        <read-only-form-field title="Res Card Number" testId="adx-invoice-info-res-card-number" value="{{_adxInvoice.resCardNumber}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-external-invoice-number-grid-tile">
                        <read-only-form-field title="External Invoice Number" testId="adx-invoice-info-external-invoice-number" value="{{_adxInvoice.externalInvoiceNumber}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-arc-no-grid-tile">
                        <read-only-form-field title="ARC Number" testId="adx-invoice-info-arc-no" value="{{_adxInvoice.arcNo}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-erp-sales-order-number-grid-tile">
                        <read-only-form-field title="ERP Sales Order Number" testId="adx-invoice-info-erp-sales-order-number" value="{{_adxInvoice.erpSalesOrderNumber}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-invoice-info-payload-grid-tile" *ngIf="payload">
                        <div class="read-only-form-field">
                            <label>Invoice Payload</label>
                            <a data-testid="adx-invoice-info-view-payload-link"
                               href="javascript:void(0)"
                               style="color: #0078d4; text-decoration: underline; cursor: pointer;"
                               (click)="viewPayload()">View Payload</a>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-card-content>
        </mat-card>
    </div>
</form>